import { Component, OnInit, ViewChild } from '@angular/core';
import { NavController, ModalController, Platform} from '@ionic/angular';
  
import { Stylist } from '../../../models/stylist/stylist.model';
import { ServiceCategory } from '../../../models/service-category/service-category.model';
import { ServiceDefinition } from '../../../models/service-definition/service-definition.model';
import { UserService } from '../../../services/user.service';
import { ServiceCategoryService } from '../../../services/service-category.service';
import { StylistService } from '../../../services/stylist.service';
import { StylistPickerComponent } from '../../../components/stylist-picker/stylist-picker.component';
import { AllStylistServiceManagerComponent } from './all-stylist-service-manager/all-stylist-service-manager.component';
import { ServiceDetailFormComponent } from '../service-detail-form/service-detail-form.component';
import { ServiceCategoryFormComponent } from '../service-category-form/service-category-form.component';  
  

import { OnBoardingService } from '../../../services/on-boarding.service';

import { IServiceCategorySelectEvent, IServiceDefinitionSelectEvent } from '../../../components/service-definition-list/service-definition-list.component';
import { List } from 'immutable';
import { Router, ActivatedRoute } from '@angular/router';
declare var posthog: any;
@Component({
  selector: 'app-service-manager',
  templateUrl: './service-manager.page.html',
  styleUrls: ['./service-manager.page.scss'],
})
export class ServiceManagerPage implements OnInit {


 @ViewChild(StylistPickerComponent) stylistPickerComponent: StylistPickerComponent;
 @ViewChild(AllStylistServiceManagerComponent) allStylistServiceManagerComponent: AllStylistServiceManagerComponent;

  public isLoading: boolean;

  public errorOccurredWhileLoadingStylists: boolean;

  public errorOccurredWhileLoadingServices: boolean;

  public submitted: boolean;

  public savingInProgress: boolean;

  public stylistID: number;

  public stylist: Stylist;

  public readOnlyStylistPicker: boolean;

  public modal: boolean;

  public salonServiceCategories: List<ServiceCategory>;

  public serviceCategoriesOffered: List<ServiceCategory>;

  public serviceCategoriesNotOffered: List<ServiceCategory>;

  private firstLoad: boolean;

  public showAllStaffManager: boolean;

  public stylistNum: number;

  constructor (
              //private navController: NavController,
              //private navCtrl: NavController,
              private modalCtrl: ModalController,
              private userService: UserService,
              private onBoardingService: OnBoardingService,
              private platform: Platform,
              private serviceCategoryService: ServiceCategoryService,
              private route: ActivatedRoute,
              private router:Router,
              private stylistService: StylistService) {
    this.salonServiceCategories = List([]);
    this.serviceCategoriesOffered = List([]);
    this.serviceCategoriesNotOffered = List([]);
    this.firstLoad = true;
    this.isLoading = true;
    this.readOnlyStylistPicker = true;
    // this.modal = this.navParams.get('modal');
    this.modal = route.snapshot.params.modal;
    if (this.userService.isLoggedIn()) {
      const user = this.userService.getUser();
      this.stylistID = user.getID();
      if (user.isAdministrator()) {
        this.stylistID = 0;
        this.readOnlyStylistPicker = false;
      } else {
        this.readOnlyStylistPicker = true;
      }
    }
  }

  public ionViewCanEnter () {
  }
  ionViewWillEnter() {
    this.allStylistServiceManagerComponent.loadServices();
  }
  public ngOnInit () {
    this.onBoardingService.getStylistOnBoarding()
      .subscribe((stylistOnboarding) => {

        if (this.onBoardingService.isServicesOnboardingDone()) {
          return;
        }

        stylistOnboarding = stylistOnboarding.setServices(1);
        this.onBoardingService.save(stylistOnboarding)
          .subscribe((onboarding) => {});
      });
      this.stylistService.getStylists().subscribe((stylists) => {
        this.stylistNum = stylists.filter(stylist => {return stylist.active != 0}).count();
      });
  }

   public showAllStylistServiceManager () : boolean {

     return this.stylist.getID() == 0 || (this.userService.getSalon().planID === 1 || this.userService.getSalon().planID === 2) || this.stylistNum == 1
   }

  public onStylistPickerInit (initResponse: {success: boolean, stylist: Stylist}) {
    if (initResponse.success) {
      this.onStylistSelect(initResponse.stylist);
    } else {
      this.isLoading = false;
      this.errorOccurredWhileLoadingStylists = true;
    }
  }

  public tapToRetry () {
    if (this.errorOccurredWhileLoadingStylists) {
      this.errorOccurredWhileLoadingStylists = false;
      this.stylistPickerComponent.ngOnInit();
    } else if (this.errorOccurredWhileLoadingServices) {
      this.errorOccurredWhileLoadingServices = false;
      this.onStylistSelect(this.stylist);
    }
  }

  public onStylistSelect (stylist: Stylist) {
    if (stylist) {
      this.isLoading = true;
      this.errorOccurredWhileLoadingServices = false;
      this.stylistID = stylist.getID();
      this.stylist = stylist;

      // load service categories offered by this stylist
      this.serviceCategoryService.getServiceCategories(this.stylist.getID(), this.userService.getSalon().getId(),true)
        .subscribe({
          next:(serviceCategoriesOffered)=>{
            this.serviceCategoriesOffered = serviceCategoriesOffered;

            // load all service categories of the salon on first load
            if (this.firstLoad) {
              this.serviceCategoryService.getSalonServiceCategories()
              .subscribe({
                next:(salonServiceCategories)=>{
                  this.salonServiceCategories = salonServiceCategories;
                  this.showSalonServiceCategoriesNotOfferedByThisStylist();
                  this.firstLoad = false;
                  this.isLoading = false;
                },
                error :(e)=> {
                  this.isLoading = false;
                  this.errorOccurredWhileLoadingServices = true;
                }
                
              });
            } else {
              this.showSalonServiceCategoriesNotOfferedByThisStylist();
              this.isLoading = false;
            }
          },
          error:(e) => {
            this.isLoading = false;
            this.errorOccurredWhileLoadingServices = true;
          }
        });
    }
  }

  public showSalonServiceCategoriesNotOfferedByThisStylist () {
    this.salonServiceCategories.forEach((salonServiceCategory: ServiceCategory) => {

      // check if this is not category is not offered by this stylst
      const result = this.serviceCategoriesOffered.filter((stylistServiceCategory: ServiceCategory) => stylistServiceCategory.id === salonServiceCategory.id).toList();
      
      if (result.count() === 0) {
        
        // add this salon service category
        this.serviceCategoriesOffered = this.serviceCategoriesOffered.push(salonServiceCategory.setServiceDefinitions(List([])));
      }

    });
  }
}
